module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentQindex < _vm.totalQuestions),
      expression: "currentQindex < totalQuestions"
    }],
    attrs: {
      "id": "score"
    }
  }, [_c('div', {
    staticClass: "col-1-3 left"
  }, [_vm._v("Stoichiometry")]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3 center"
  }, [_vm._v("question " + _vm._s(_vm.currentQindex + 1) + " / " + _vm._s(_vm.totalQuestions))]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3 right"
  }, [_vm._v("score: " + _vm._s(_vm.currentScore) + " / " + _vm._s(_vm.totalQuestions * 3))])])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentQindex < _vm.totalQuestions),
      expression: "currentQindex < totalQuestions"
    }],
    key: "questionsstart"
  }, _vm._l((_vm.randomQuestions), function(q, index) {
    return _c('div', {
      key: 'q' + index
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.currentQindex),
        expression: "index === currentQindex"
      }],
      key: 'qi' + index
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.debug === true),
        expression: "debug === true"
      }],
      staticClass: "debug"
    }, [_vm._v("\n            Question " + _vm._s(_vm.currentQindex + 1) + " part " + _vm._s(_vm.currentsubQindex + 1)), _c('br'), _vm._v("\n            component: " + _vm._s(q.component)), _c('br'), _vm._v("\n            ANSWERS:"), _c('br'), _vm._v("\n            part 1: [ " + _vm._s(q.first) + " ]"), _c('br'), _vm._v("\n            part 2: " + _vm._s(q.second)), _c('br'), _vm._v("\n            part 3: " + _vm._s(q.answer) + " (" + _vm._s(q.aorb) + ")"), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "question"
    }, [_c('div', {
      staticClass: "subQs"
    }, [_c('div', {
      staticClass: "wrap"
    }, [(_vm.currentsubQindex == 0) ? _c('p', [_vm._v("Classify the following reaction")]) : _vm._e(), _vm._v(" "), (_vm.currentsubQindex == 1) ? _c('p', [_vm._v("Balance the equation")]) : _vm._e(), _vm._v(" "), (_vm.currentsubQindex == 2) ? _c('p', {
      class: _vm.thirdCheck == 'right' ? 'faded' : '',
      domProps: {
        "innerHTML": _vm._s(q.question)
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "equation",
      class: _vm.currentEqClass()
    }, [_c(q.component, {
      key: q.component,
      tag: "component",
      attrs: {
        "secondGuess": _vm.secondGuess
      },
      on: {
        "update:secondGuess": function($event) {
          _vm.secondGuess = $event
        },
        "setSecond": function($event) {
          _vm.setSecond($event)
        }
      }
    })], 1), _vm._v(" "), (_vm.currentsubQindex == 0) ? _c('div', {
      staticClass: "wrap"
    }, [_c('div', {
      staticClass: "part-1-answers radio-inputs"
    }, _vm._l((['decomposition', 'synthesis', 'single replacement', 'double replacement', 'combustion']), function(answer, i) {
      return _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.firstGuess[index]),
          expression: "firstGuess[index]"
        }],
        attrs: {
          "disabled": _vm.firstCheck != '' ? true : false,
          "name": index + '_guess-option',
          "id": index + '_' + i,
          "type": "radio",
          "autocomplete": "off"
        },
        domProps: {
          "value": answer,
          "checked": _vm._q(_vm.firstGuess[index], answer)
        },
        on: {
          "change": function($event) {
            _vm.$set(_vm.firstGuess, index, answer)
          }
        }
      }), _vm._v(" "), _c('label', {
        class: [{
          wasnt: (q.first == answer)
        }, _vm.firstCheck],
        attrs: {
          "for": index + '_' + i
        },
        on: {
          "click": _vm.setFirst
        }
      }, [_vm._v(_vm._s(answer))])])
    })), _vm._v(" "), _c('div', {
      staticClass: "submit"
    }, [(_vm.firstCheck == 'wrong') ? _c('p', {
      staticClass: "wrong red"
    }, [_vm._v("Sorry, that is incorrect.")]) : _vm._e(), _vm._v(" "), (_vm.firstCheck == 'right') ? _c('p', {
      staticClass: "wrong"
    }, [_vm._v("Correct!")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn",
      on: {
        "click": _vm.submitFirst
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.submitText)
      }
    })])])]) : _vm._e(), _vm._v(" "), (_vm.currentsubQindex == 1) ? _c('div', {
      staticClass: "wrap"
    }, [_c('div', {
      staticClass: "submit"
    }, [(_vm.secondCheck == 'wrong') ? _c('p', {
      staticClass: "wrong red"
    }, [_vm._v("Sorry, that is incorrect. Please try again.")]) : _vm._e(), _vm._v(" "), (_vm.secondWrong == 'deadwrong') ? _c('p', {
      staticClass: "wrong red"
    }, [_vm._v("Sorry, that is incorrect. The correct answer is shown.")]) : _vm._e(), _vm._v(" "), (_vm.secondCheck == 'right') ? _c('p', {
      staticClass: "wrong"
    }, [_vm._v("Correct!")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn",
      on: {
        "click": _vm.submitSecond
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.submitText)
      }
    })])])]) : _vm._e(), _vm._v(" "), (_vm.currentsubQindex == 2) ? _c('div', {
      staticClass: "part-3-container wrap",
      class: [{
        fade: (_vm.thirdCheck == 'right')
      }, {
        fader: (_vm.thirdCheck == 'deadwrong')
      }]
    }, [_c('div', {
      staticClass: "part-3-answers equation on"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.thirdGuess[index]),
        expression: "thirdGuess[index]"
      }],
      attrs: {
        "type": "text",
        "pattern": "[0-9]*[.,]?[0-9]+",
        "autocomplete": "off",
        "step": "0.0001"
      },
      domProps: {
        "value": (_vm.thirdGuess[index])
      },
      on: {
        "focus": _vm.setThird,
        "click": _vm.setThird,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.thirdGuess, index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(q.answerTemplate)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "submit"
    }, [(_vm.thirdCheck == 'wrong') ? _c('p', {
      staticClass: "red"
    }, [_vm._v("Sorry, that value is incorrect. Please recheck your calculations and try again.")]) : _vm._e(), _vm._v(" "), (_vm.thirdCheck == 'deadwrong') ? _c('p', {
      staticClass: "red"
    }, [_vm._v("Sorry, that value is incorrect. The correct answer is shown.")]) : _vm._e(), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.thirdCheck != 'wrong' && _vm.thirdCheck != 'deadwrong'),
        expression: "thirdCheck != 'wrong' && thirdCheck != 'deadwrong'"
      }],
      staticClass: "sigfig",
      class: _vm.thirdCheck == 'sigfig' ? 'red' : ''
    }, [_vm._v("Final answers should be reported with the correct number of significant digits")]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.thirdCheck != 'deadwrong'),
        expression: "thirdCheck != 'deadwrong'"
      }],
      staticClass: "btn",
      on: {
        "click": _vm.submitThird
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.submitText)
      }
    })])]), _vm._v(" "), (_vm.thirdCheck == 'right') ? _c('div', {
      staticClass: "q-complete"
    }, [_c('span', [_vm._v("Correct!")]), _c('br'), _vm._v("Question " + _vm._s(_vm.currentQindex + 1) + " Complete\n                ")]) : _vm._e(), _vm._v(" "), (_vm.thirdCheck == 'right' || _vm.thirdCheck == 'deadwrong') ? _c('div', {
      staticClass: "q-next"
    }, [_c('button', {
      staticClass: "btn",
      on: {
        "click": _vm.nextQuestion
      }
    }, [_vm._v("Next Question ⟶")])]) : _vm._e()]) : _vm._e()])])])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentQindex === _vm.totalQuestions),
      expression: "currentQindex === totalQuestions"
    }],
    key: "outroend",
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "outro"
  }, [_c('div', {
    staticClass: "outro-inner"
  }, [_c('h1', [_vm._v("You completed the quiz!")]), _vm._v(" "), _c('p', [_vm._v("Your final score is "), _c('span', [_vm._v(_vm._s(_vm.currentScore))]), _vm._v(" / " + _vm._s(_vm.totalQuestions * 3))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "id": "reset"
    },
    on: {
      "click": _vm.resetEverything
    }
  }, [_vm._v("Start over")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c23d893","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Quiz.vue
// module id = 71
// module chunks = 1